import styled, { css } from 'styled-components'

import { Carousel } from '@/components'

export type TimelineContainerProps = {
  isSelectedLeft: boolean
  isSelectedRight: boolean
}

export const TimelineContainer = styled(Carousel)`
  justify-content: center;
  .timeline-items {
    display: flex;
    flex-direction: column;
    width: 100%;
    align-items: center;
  }
`

export const TimelineDot = styled.span<TimelineContainerProps>`
  display: block;
  position: relative;
  width: 100%;
  height: 4px;
  &:after {
    content: '';
    background-color: ${({ theme, isSelectedLeft }) =>
      isSelectedLeft ? theme.colors.primary : ' #8D8D8D'};
    position: absolute;
    height: 4px;
    width: 50%;
    bottom: 5px;
    left: 0;
    z-index: ${(props) => (props.isSelectedLeft ? -1 : 2)};
  }
  &::before {
    content: '';
    background-color: ${({ theme, isSelectedRight }) =>
      isSelectedRight ? theme.colors.primary : ' #8D8D8D'};
    position: absolute;
    height: 4px;
    width: 50%;
    bottom: 5px;
    right: 0;
    z-index: ${(props) => (props.isSelectedRight ? -1 : 2)};
  }
`

export type ArrowImageProps = {
  side: 'left' | 'right'
  lastYear?: boolean
  firstYear?: boolean
}

export const ArrowContainer = styled.div<ArrowImageProps>`
  display: flex;
  justify-content: center;

  background-color: ${({ theme }) => theme.colors.white};
  width: 40px;
  height: 12px;
  position: absolute;
  bottom: 0;
  ${({ side }) => side}: 0;
  z-index: 1;
  ${({ side }) =>
    side === 'left'
      ? css`
          left: 0;
        `
      : css`
          right: 0;
        `};
`

export const ArrowImage = styled.span<ArrowImageProps>`
  height: 9px;
  width: 13px;
  z-index: 2;
  transition: transform 0.2s ease-in-out;
  cursor: default;
  position: relative;

  &:before {
    content: '';
    display: flex;
    position: absolute;
    padding: 4px;
    box-shadow: 2px -2px 0 0px ${({ firstYear, lastYear, theme }) =>
        firstYear || lastYear ? theme.colors.primary : '#8D8D8D'} inset;
    border: solid transparent;
    border-width: 0 0 2px 2px;
    rotate: ${(props) => (props.side === 'left' ? '45deg' : '-135deg')};
    left: ${(props) => (props.side === 'left' ? '-0.5rem' : '0.5rem')};
  }

  &:after {
    content: '';
    display: flex;
    position: absolute;
    border: 1px solid
      ${({ firstYear, lastYear, theme }) =>
        firstYear || lastYear ? theme.colors.primary : '#8D8D8D'};
    width: 12px;
    top: 4px;
    right: ${(props) => (props.side === 'left' ? '3px' : '-1px')};
  }

  ${({ firstYear, lastYear }) =>
    !firstYear &&
    !lastYear &&
    css`
      &:hover {
        transform: scale(1.3);
        cursor: pointer;
        &:before {
          box-shadow: 2px -2px 0 0px ${({ theme }) => theme.colors.primary} inset;
        }
        &:after {
          border: 1px solid ${({ theme }) => theme.colors.primary};
        }
      }
    `}
`
export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  column-width: calc(50% - 80px);

  .content-title {
    margin-bottom: 0.5rem;
    margin-top: 1.5rem;
  }

  .content-description {
    column-count: 2;
    column-width: calc(50% - 80px);
    column-gap: 80px;

    @media (max-width: 990px) {
      column-count: 1;
    }
  }
`

export const OurHistoryContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  background-color: ${({ theme }) => theme.colors.white};
  max-width: 1170px;

  @media (max-width: 1180px) {
    padding: 0 16px;
  }

  .title {
    margin-bottom: 48px;
    @media (max-width: 861px) {
      font-size: 50px;
    }
    @media (max-width: 670px) {
      font-size: 25px;
    }
  }

  @media (max-width: 800px) {
    align-items: flex-start;
  }
`
